import type { Plugin } from 'vue';
import { createI18n } from 'vue-i18n';
import cs from '@/locales/cs.json';
import de from '@/locales/de.json';
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import fr from '@/locales/fr.json';
import nl from '@/locales/nl.json';
import pl from '@/locales/pl.json';
import ptBr from '@/locales/pt-br.json';
import pt from '@/locales/pt.json';

const i18n = createI18n({
  legacy: false,
  locale: 'en', // this "en" here will be overwritten by the useGlobal's watcher
  messages: {
    cs,
    de,
    en,
    es,
    fr,
    nl,
    pl,
    'pt-br': ptBr,
    pt,
  },
  silentFallbackWarn: true,
});

const plugin: Plugin = {
  install(app) {
    app.use(i18n);
  },
};

export default plugin;
